import React, {Component} from 'react';
import {createMuiTheme, MuiThemeProvider, CircularProgress} from "@material-ui/core/index";
import "./App.css";
import Colors from "./components/CustomColors";
import WidgetEditor from "./components/WidgetEditor";
import ErrorHandler from "./components/ErrorHandler";
import Widget from "./components/Widget";
import * as Utility from "./components/Utility";

class App extends Component {

    /* ------ LIFECYCLE --------*/

    constructor(props) {
        super(props);

        let apiKeyUrlParam = new URLSearchParams(window.location.search.slice(1)).get("apikey");

        this.state = {
            widgetNumber: new URLSearchParams(window.location.search.slice(1)).get("wn"),
            apiKey: apiKeyUrlParam,
            widgetHash: new URLSearchParams(window.location.search.slice(1)).get("widget_hash"),
            language: new URLSearchParams(window.location.search.slice(1)).get("lang"),
            channelLanguage: new URLSearchParams(window.location.search.slice(1)).get("channel_language"),
            wbdomain: new URLSearchParams(window.location.search.slice(1)).get("wbdomain"),
            isPreview: new URLSearchParams(window.location.search.slice(1)).get("pre"),
            referral: new URLSearchParams(window.location.search.slice(1)).get("ref"),
            service: new URLSearchParams(window.location.search.slice(1)).get("service"),
            baseUrl: apiKeyUrlParam ? "https://widget2.messengerpeople.com/" : "https://wb.messengerpeople.com/",
            translation: {},
            widgets: [],
            phoneNumbers: [],
            widget: 0,
            isTranslationLoaded: !apiKeyUrlParam,
            isDefaultLoaded: !apiKeyUrlParam,
            //isApiKeyValidationFinished: !apiKeyUrlParam,
            isApiKeyValidationFinished: true,
            //isApiKeyValid: false,
            isApiKeyValid: true,
            isWidgetDataLoaded: false,
            defaultData: null,
        };

        if (apiKeyUrlParam) {
            //this.validateApiKey();
            this.getTranslation();
            this.getDefaultData();
        }
        this.getWidget();
    }

    /* ------ UTILITY -------- */

    getTranslation() {
        fetch(this.state.baseUrl + "lang_" + this.state.language + ".json")
            .then(res => res.json())
            .then(
                (result) => {
                    if (window.location.search.indexOf("debug") !== -1) {
                        console.log(result);
                    }
                    if (result.code !== 200) {
                        console.error("Something went wrong: get language");
                        return;
                    }
                    this.setState({translation: result.translation}, () => {
                        this.setState({isTranslationLoaded: true})
                    });
                },
                (error) => {
                    this.setState({
                        isTranslationLoaded: true,
                    });
                    console.error(error);
                }
            );
    };

    getDefaultData() {
        let url = "https://rest.messengerpeople.com/api/v8/internal/defaultwidget?lang=" + this.state.language;
        if (this.state.service === "1") {
            url += "&service=1";
        }
        fetch(url)
            .then(res => res.json())
            .then(
                (result) => {
                    if (window.location.search.indexOf("debug") !== -1) {
                        console.log(result);
                    }
                    this.setState({
                        defaultData: result,
                        isDefaultLoaded: true
                    });
                },
                (error) => {
                    this.setState({
                        isDefaultLoaded: true,
                    });
                    console.error(error);
                    return null;
                }
            )
    };

    getWidget() {
        fetch(this.state.baseUrl + "data_" + this.state.widgetHash + ".json")
            .then(res => res.json())
            .then(
                (result) => {
                    if (window.location.search.indexOf("debug") !== -1) {
                        console.log(result);
                    }
                    if (result.code) {
                        console.error("Something went wrong: get widget");
                        return null;
                    }

                    if (!result.data || !result.data.widgets) {
                        this.setState({
                            widgets: null,
                            phoneNumbers: result.rufnummern,
                            messengerData: result.messenger,
                            isWidgetDataLoaded: true
                        });

                        return;
                    }

                    const filteredWidgets = [];
                    result.data.widgets.forEach(widget => {
                        const enabledMessenger = Utility.getEnabledMessenger(
                            widget.config,
                            result.messenger
                        );
                        const newWidget = Object.assign({}, widget);
                        newWidget.config.messenger = enabledMessenger;
                        filteredWidgets.push(newWidget);
                    });

                    this.setState({
                        widgets: filteredWidgets,
                        phoneNumbers: result.rufnummern,
                        messengerData: result.messenger,
                        isWidgetDataLoaded: true
                    });
                },
                (error) => {
                    this.setState({
                        isWidgetDataLoaded: true,
                    });
                    console.error(error);
                    return null;
                }
            );
    };

    /* ------ HTML --------*/

    getApp() {
        if (this.state.apiKey) {
            if (this.state.isApiKeyValid) {
                return (
                    <WidgetEditor
                        widgets={this.state.widgets}
                        language={this.state.language}
                        channelLanguage={this.state.channelLanguage}
                        translation={this.state.translation}
                        apiKey={this.state.apiKey}
                        widgetHash={this.state.widgetHash}
                        phoneNumbers={this.state.phoneNumbers}
                        defaultData={this.state.defaultData}
                        messengerData={this.state.messengerData}
                        wbdomain={this.state.wbdomain}
                    />
                );
            } else {
                return <h1>Authentication failed...</h1>;
            }
        } else {
            if (!this.state.widgets) {
                return (<div>
                    <h1>Widget not found...</h1>
                </div>);
            }

            let config = this.state.widgets[this.state.widgetNumber].config;

            if (this.state.isPreview) {
                return (
                    <div style={{
                        marginTop: 16,
                        height: config.appearance.height + 10,
                        width: config.appearance.width + 10
                    }}>
                        <div style={{width: "100%", height: "100%"}}>
                            <Widget
                                config={config}
                                phoneNumbers={this.state.phoneNumbers}
                                messengerData={this.state.messengerData}
                                referral={this.state.referral}
                                widgetHash={this.state.widgetHash}
                            />
                        </div>
                    </div>
                );
            } else {
                return (
                    <div style={{margin: 8, width: "100%"}}>
                        <Widget
                            config={config}
                            phoneNumbers={this.state.phoneNumbers}
                            messengerData={this.state.messengerData}
                            referral={this.state.referral}
                            widgetHash={this.state.widgetHash}
                        />
                    </div>
                );
            }
        }
    }

    /* ------ RENDER --------*/

    render() {
        const theme = createMuiTheme({
            palette: {
                primary: {
                    main: Colors.whatsgreen,
                    contrastText: Colors.lightText,
                },
                secondary: {
                    main: Colors.lightText,
                }
            },
        });

        if (this.state.isWidgetDataLoaded && this.state.isTranslationLoaded && this.state.isDefaultLoaded && this.state.isApiKeyValidationFinished) {
            return (
                <div className="app">
                    <ErrorHandler>
                        <MuiThemeProvider theme={theme}>
                            {this.getApp()}
                        </MuiThemeProvider>
                    </ErrorHandler>
                </div>
            );
        }

        return (
            <div className="flex-row">
                <div className="flex-column">
                    <MuiThemeProvider theme={theme}>
                        <CircularProgress color="primary" thickness={4}/>
                    </MuiThemeProvider>
                </div>
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js